import { lazy } from 'react';

const MaterialSaleRecordsManufacturerConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/manufacturer/consult/material-sale-records',
			component: lazy(() => import('./MaterialSaleRecordsContainer'))
		}
	]
};

export default MaterialSaleRecordsManufacturerConfig;
